var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20H11.25ZM12.75 20C12.75 19.3096 13.3096 18.75 14 18.75V17.25C12.4812 17.25 11.25 18.4812 11.25 20H12.75ZM15 6.75H20V5.25H15V6.75ZM20.25 7V17H21.75V7H20.25ZM12.75 20V9H11.25V20H12.75ZM20.25 17C20.25 17.1381 20.1381 17.25 20 17.25V18.75C20.9665 18.75 21.75 17.9665 21.75 17H20.25ZM20 6.75C20.1381 6.75 20.25 6.86193 20.25 7H21.75C21.75 6.0335 20.9665 5.25 20 5.25V6.75ZM15 5.25C12.9289 5.25 11.25 6.92893 11.25 9H12.75C12.75 7.75736 13.7574 6.75 15 6.75V5.25ZM20 17.25H14V18.75H20V17.25ZM12.75 20C12.75 18.4812 11.5188 17.25 10 17.25V18.75C10.6904 18.75 11.25 19.3096 11.25 20H12.75ZM9 5.25H4V6.75H9V5.25ZM2.25 7V17H3.75V7H2.25ZM2.25 17C2.25 17.9665 3.0335 18.75 4 18.75V17.25C3.86193 17.25 3.75 17.1381 3.75 17H2.25ZM4 5.25C3.0335 5.25 2.25 6.0335 2.25 7H3.75C3.75 6.86193 3.86193 6.75 4 6.75V5.25ZM9 6.75C10.2426 6.75 11.25 7.75736 11.25 9H12.75C12.75 6.92893 11.0711 5.25 9 5.25V6.75ZM4 18.75H10V17.25H4V18.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserGuide);
export default __webpack_public_path__ + "static/media/icon-user-guide.8ab037c2710450b0b8bdc52214c3fa72.svg";
export { ForwardRef as ReactComponent };